// extracted by mini-css-extract-plugin
export var formContainer = "_lj-0";
export var message = "_lj-1";